export const tabsSemanticTokens = {
  bg: {
    enclosed: { value: "{colors.primary.white}" },
    enclosedActive: { value: "{colors.green.500}" },
  },
  text: {
    enclosed: { value: "{colors.green.500}" },
    enclosedActive: { value: "{colors.primary.white}" },
  },
  fontSizes: {
    lg: { value: "fontSizes.lg" },
  },
  radii: {
    enclosed: { value: "radii.5xl" },
  },
  fontWeights: {
    normal: { value: "fontWeights.normal" },
    bold: { value: "fontWeights.bold" },
  },
  border: {
    enclosed: { value: "{colors.gray.200}" },
    enclosedActive: { value: "{colors.green.500}" },
  },
};
